import { defineMessages } from 'react-intl';

const translations = {
  breadcrumb: {
    shipments: {
      id: 'pages.shipmentView.breadcrumb.shipments',
      defaultMessage: 'Shipments',
      description: 'label of the shipment breadcrumb',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.shipmentView.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details tab on the shipment view page',
    },
    items: {
      id: 'pages.shipmentView.subNavigation.items',
      defaultMessage: 'Items',
      description: 'label of the items tab on the shipment view page',
    },
    parcels: {
      id: 'pages.shipmentView.subNavigation.parcels',
      defaultMessage: 'Parcels',
      description: 'label of the parcels tab on the shipment view page',
    },
    overage: {
      id: 'pages.shipmentView.subNavigation.overage',
      defaultMessage: 'Overage',
      description: 'label of the overage tab on the shipment view page',
    },
    logs: {
      id: 'pages.shipmentView.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'label of the logs tab on the shipment view page',
    },
  },
  secondaryActions: {
    cancelShipment: {
      id: 'pages.shipmentView.secondaryActions.cancelShipment',
      defaultMessage: 'Cancel shipment',
      description: 'label of the cancel shipment secondary action',
    },
    finishShipment: {
      id: 'pages.shipmentView.secondaryActions.finishShipment',
      defaultMessage: 'Finish shipment',
      description: 'label of the finish shipment secondary action',
    },
    updatePositions: {
      id: 'pages.shipmentView.secondaryActions.updatePositions',
      defaultMessage: 'Update positions',
      description: 'label of the update positions secondary action',
    },
    triggerDataFlow: {
      id: 'pages.shipmentView.secondaryActions.triggerDataFlow',
      defaultMessage: 'Update positions',
      description: 'label of the update positions secondary action',
    },
  },
  actions: {
    edit: {
      id: 'pages.shipmentView.actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
    pick: {
      id: 'pages.shipmentView.actions.pick',
      defaultMessage: 'Pick',
      description: 'label of the pick button',
    },
    pickAndBox: {
      id: 'pages.shipmentView.actions.pickAndBox',
      defaultMessage: 'Pick & Box',
      description: 'label of the pick and box button',
    },
    place: {
      id: 'pages.shipmentView.actions.place',
      defaultMessage: 'Place',
      description: 'label of the place button',
    },
    start: {
      id: 'pages.shipmentView.actions.start',
      defaultMessage: 'Start',
      description: 'label of the start button',
    },
    pack: {
      id: 'pages.shipmentView.actions.pack',
      defaultMessage: 'Pack',
      description: 'label of the pack button',
    },
    unpack: {
      id: 'pages.shipmentView.actions.unpack',
      defaultMessage: 'Unpack',
      description: 'label of the unpack button',
    },
  },
  finishShipmentDialog: {
    message: {
      id: 'pages.shipmentView.finishShipmentDialog.message',
      defaultMessage: 'Finishing shipment',
      description: 'Progress message of the finish shipment action',
    },
  },
  updatePositionsDialog: {
    title: {
      id: 'pages.shipmentView.updatePositionsDialog.title',
      defaultMessage: 'Update item positions',
      description: 'Title of the update positions dialog',
    },
    description: {
      id: 'pages.shipmentView.updatePositionsDialog.description',
      defaultMessage:
        'Are you sure you would like to update the item positions on this shipment to the latest preferred positions? The existing item positions will be overwritten.',
      description: 'Description of the update positions dialog',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button in the update positions dialog',
      },
      update: {
        id: 'actions.update',
        defaultMessage: 'Update',
        description: 'Label of the update button in the update positions dialog',
      },
    },
  },
  cancelShipmentDialog: {
    title: {
      id: 'cancelShipmentDialog.title',
      defaultMessage: 'Cancel shipment',
      description: 'Title of the cancel shipment dialog',
    },
    description: {
      id: 'cancelShipmentDialog.description',
      defaultMessage: 'Are you sure you would like to cancel the shipment?',
      description: 'Description of the cancel shipment dialog',
    },
    buttons: {
      cancelShipment: {
        id: 'cancelShipmentDialog.buttons.cancelShipment',
        defaultMessage: 'Cancel shipment',
        description: 'Label of the cancel shipment action of the cancel shipment dialog',
      },
      close: {
        id: 'actions.close',
        defaultMessage: 'Close',
        description: 'Label of the close action of the cancel shipment dialog',
      },
    },
  },
  feedback: {
    shipmentFinished: {
      id: 'pages.shipmentView.feedback.shipmentFinished',
      defaultMessage: 'Shipment finished',
      description: 'Success message of the finish shipment action',
    },
    shipmentNotFinished: {
      id: 'pages.shipmentView.feedback.shipmentNotFinished',
      defaultMessage: 'Shipment could not be finished',
      description: 'Error message of the finish shipment action',
    },
    positionsUpdated: {
      id: 'pages.shipmentView.feedback.positionsUpdated',
      defaultMessage: 'Item positions updated',
      description: 'Success message of the update positions action',
    },
    positionsNotUpdated: {
      id: 'pages.shipmentView.feedback.positionsNotUpdated',
      defaultMessage: 'Item positions could not be updated',
      description: 'Error message of the update positions action',
    },
    shipmentCancelled: {
      id: 'pages.shipmentView.feedback.shipmentCancelled',
      defaultMessage: 'Shipment cancelled',
      description: 'Success message of the cancel shipment action',
    },
    shipmentNotCancelled: {
      id: 'pages.shipmentView.feedback.shipmentNotCancelled',
      defaultMessage: 'Shipment could not be cancelled',
      description: 'Error message of the cancel shipment action',
    },
  },
};

export default defineMessages(translations);
